import styled from 'styled-components';
import { Colors } from '../../constants/Colors';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${Colors?.bgLight || '#f2f2f2'};
  padding: 20px;
`;

export const ButtonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 40vw);
  grid-template-rows: repeat(3, 40vw);
  gap: 20px;

  @media (min-width: 600px) {
    grid-template-columns: repeat(3, 200px);
    grid-template-rows: repeat(2, 200px);
  }
`;

export const LaundryButton = styled.button`
  background-color: ${Colors?.primary?.[100] || '#3C3972'};
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  transition: 0.2s;
  width: 100%;
  height: 100%;

  &:hover {
    background-color: ${Colors?.primary?.[80] || '#3C397280'};
  }

  &:active {
    transform: scale(0.97);
  }
`;
